import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
export default function RemoteProjectsScreen() {
  return <View style={{ padding: 24 }}><Text>Open Remote projects in the Gab AI mobile app. Manage shared folders in Remote access settings on your Mac.</Text></View>;
}
